exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-594a0f30]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-594a0f30]{display:none !important}}.m-product-options-custom[data-v-594a0f30]{margin:0 var(--spacer-sm)}@media (min-width: 1024px){.m-product-options-custom[data-v-594a0f30]{margin:0 var(--spacer-xl)}}.single-option[data-v-594a0f30]{margin-top:1.5rem}.sf-divider[data-v-594a0f30]{margin-top:1.5rem}\n", ""]);

// exports
